// i18n translations
export const translations = {
  ja: {
    // Navigation
    nav: {
      dashboard: 'ダッシュボード',
      contacts: '連絡先',
      files: 'ファイル',
      media: 'メディア',
      tasks: 'タスク',
      search: '検索',
      settings: '設定',
      logout: 'ログアウト',
    },
    // Auth
    auth: {
      login: 'ログイン',
      register: '新規登録',
      email: 'メールアドレス',
      password: 'パスワード',
      name: '名前',
      loginTitle: 'RK File Control',
      loginSubtitle: '書類管理 + CRM + 証跡統合システム',
      noAccount: 'アカウントをお持ちでない方',
      hasAccount: 'すでにアカウントをお持ちの方',
      loginButton: 'ログイン',
      registerButton: '登録',
    },
    // Dashboard
    dashboard: {
      title: 'ダッシュボード',
      totalContacts: '連絡先数',
      totalFiles: 'ファイル数',
      totalTasks: 'タスク数',
      pendingTasks: '未完了タスク',
      filesToday: '本日のアップロード',
      recentActivity: '最近のアクティビティ',
    },
    // Contacts
    contacts: {
      title: '連絡先管理',
      addNew: '連絡先を追加',
      name: '名前',
      company: '会社名',
      phone: '電話番号',
      email: 'メール',
      address: '住所',
      status: 'ステータス',
      tags: 'タグ',
      notes: 'メモ',
      active: 'アクティブ',
      inactive: '非アクティブ',
      lastContacted: '最終連絡日',
      noContacts: '連絡先がありません',
      viewDetails: '詳細を見る',
    },
    // Files
    files: {
      title: 'ファイル管理',
      upload: 'アップロード',
      batchUpload: '一括アップロード',
      dragDrop: 'ファイルをドラッグ＆ドロップ',
      orClick: 'またはクリックして選択',
      processing: '処理中...',
      ocrComplete: 'OCR完了',
      noFiles: 'ファイルがありません',
      download: 'ダウンロード',
      delete: '削除',
      businessCard: '名刺',
      autoDetected: '自動検出',
    },
    // Media
    media: {
      title: 'メディア管理',
      upload: 'アップロード',
      image: '画像',
      video: '動画',
      audio: '音声',
      noMedia: 'メディアがありません',
    },
    // Tasks
    tasks: {
      title: 'タスク管理',
      addNew: 'タスクを追加',
      dueDate: '期限',
      priority: '優先度',
      high: '高',
      medium: '中',
      low: '低',
      completed: '完了',
      pending: '未完了',
      noTasks: 'タスクがありません',
    },
    // Search
    search: {
      title: '検索',
      placeholder: '検索キーワードを入力...',
      textSearch: 'テキスト検索',
      aiSearch: 'AI検索',
      noResults: '結果が見つかりません',
      results: '検索結果',
    },
    // Common
    common: {
      save: '保存',
      cancel: 'キャンセル',
      delete: '削除',
      edit: '編集',
      close: '閉じる',
      loading: '読み込み中...',
      error: 'エラー',
      success: '成功',
      confirm: '確認',
      createdAt: '作成日',
      updatedAt: '更新日',
    },
  },
  en: {
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      contacts: 'Contacts',
      files: 'Files',
      media: 'Media',
      tasks: 'Tasks',
      search: 'Search',
      settings: 'Settings',
      logout: 'Logout',
    },
    // Auth
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      loginTitle: 'RK File Control',
      loginSubtitle: 'Document Management + CRM + Audit Trail System',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      loginButton: 'Sign In',
      registerButton: 'Sign Up',
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      totalContacts: 'Total Contacts',
      totalFiles: 'Total Files',
      totalTasks: 'Total Tasks',
      pendingTasks: 'Pending Tasks',
      filesToday: 'Uploads Today',
      recentActivity: 'Recent Activity',
    },
    // Contacts
    contacts: {
      title: 'Contact Management',
      addNew: 'Add Contact',
      name: 'Name',
      company: 'Company',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      status: 'Status',
      tags: 'Tags',
      notes: 'Notes',
      active: 'Active',
      inactive: 'Inactive',
      lastContacted: 'Last Contacted',
      noContacts: 'No contacts found',
      viewDetails: 'View Details',
    },
    // Files
    files: {
      title: 'File Management',
      upload: 'Upload',
      batchUpload: 'Batch Upload',
      dragDrop: 'Drag & drop files here',
      orClick: 'or click to select',
      processing: 'Processing...',
      ocrComplete: 'OCR Complete',
      noFiles: 'No files found',
      download: 'Download',
      delete: 'Delete',
      businessCard: 'Business Card',
      autoDetected: 'Auto Detected',
    },
    // Media
    media: {
      title: 'Media Management',
      upload: 'Upload',
      image: 'Image',
      video: 'Video',
      audio: 'Audio',
      noMedia: 'No media found',
    },
    // Tasks
    tasks: {
      title: 'Task Management',
      addNew: 'Add Task',
      dueDate: 'Due Date',
      priority: 'Priority',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      completed: 'Completed',
      pending: 'Pending',
      noTasks: 'No tasks found',
    },
    // Search
    search: {
      title: 'Search',
      placeholder: 'Enter search keywords...',
      textSearch: 'Text Search',
      aiSearch: 'AI Search',
      noResults: 'No results found',
      results: 'Search Results',
    },
    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      confirm: 'Confirm',
      createdAt: 'Created',
      updatedAt: 'Updated',
    },
  },
};

export const useTranslation = (language) => {
  return translations[language] || translations.ja;
};
